export default __webpack_public_path__ + "static/media/Input.2fba14c7.png";